import React from 'react';
import * as Inovx from '@shared';

var InovxControls = Inovx.Shared.Controls;
var SystemActions = Inovx.Shared.System.Actions;
import UserStore from '../stores/UserStore';
import UserActions from '../actions/UserActions';
import UserConstants from '../constants/UserConstants';
import AuthenticationModeEnum from '../constants/AuthenticationModeEnum';

var SystemStore = Inovx.Shared.System.Store;

declare var InovxLoader: any;

interface UserSystemPreferencesProps {
    onClose: () => void;
}

interface UserSystemPreferencesStates {
    dirty: boolean;
    preferences: IUserSystemPreferences;
    selectRoleIDs?: string[];
    selectEntitlementIDs?: string[];
    isActionInProgress: boolean;
    authenticationMode: string;
}

function getDefaultState(): UserSystemPreferencesStates {
    return {
        isActionInProgress: false,
        dirty: false,
        selectRoleIDs: [],
        selectEntitlementIDs: [],
        authenticationMode: UserStore.getSettings().AuthenticationMode,
        preferences: {
            DefaultSytemSetting: {
                DefaultGroupIDs: [],
                DefaultRoleIDs: []
            },
            AllGroups: [],
            AllRoles: []
        }
    };
}

function getActionInProgress() {
    return SystemStore.isActionInProgress(UserConstants.SYSTEM_SETTINGS_GET);
}

class UserSystemPreferences extends Inovx.Shared.ReactExt.BaseAppComponent<UserSystemPreferencesProps, UserSystemPreferencesStates> {

    _preferences: IUserSystemPreferences;
    _linkedEntitlements: IEntitlementGroup[] = [];
    _linkedRoles: IRole[] = [];
    constructor(props: UserSystemPreferencesProps, context: any) {
        super("System Preferences", props, context);

        this.state = getDefaultState();
        this._initialize = this._initialize.bind(this);


    }

    protected _initialize() {
        UserActions.getUserSystemPreferences((preferences: IUserSystemPreferences) => {
            this._appLoaded = true;
            var allGroups: IEntitlementGroup[] = preferences.AllGroups.slice();
            var allRoles: IRole[] = preferences.AllRoles.slice();
            allGroups.forEach(function (obj) { if (obj.IsLinkedGroup) { obj.Name = obj.Name + " " + InovxLoader.t('users:preferences.linked') }; });
            allRoles.forEach(function (obj) { if (obj.IsLinkedRole) { obj.Name = obj.Name + " " + InovxLoader.t('users:preferences.linked') }; });
            this.setState({
                dirty: false,
                preferences:
                        {
                            DefaultSytemSetting: preferences.DefaultSytemSetting,
                            AllGroups: allGroups,
                            AllRoles: allRoles
                        },
                selectEntitlementIDs: preferences.DefaultSytemSetting.DefaultGroupIDs,
                selectRoleIDs: preferences.DefaultSytemSetting.DefaultRoleIDs
            });

            var hasSSO = this.state.authenticationMode != AuthenticationModeEnum.LocalOnly;
            this._preferences = {
                DefaultSytemSetting: {
                    DefaultGroupIDs: hasSSO? [] : allGroups.filter((item) => item.Name == "User").map((item) => item.ID),
                    DefaultRoleIDs: []
                },
                AllGroups: allGroups.slice(0),
                AllRoles: allRoles.slice(0)
            };

            this._linkedEntitlements = allGroups.filter(group => group.IsLinkedGroup);
            this._linkedRoles = allRoles.filter(role => role.IsLinkedRole);

        }, null);
    }
    componentWillMount() {
        this.componentWillMountBase();
        SystemStore.addChangeListener(this._onSystemChange);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this._checkForUnsavedChangesWindow);
        SystemStore.removeChangeListener(this._onSystemChange);
    }

    componentDidMount() {
        window.addEventListener('beforeunload', this._checkForUnsavedChangesWindow);

    }


    private _onSave = (e: React.MouseEvent) => {
        if (e && e.stopPropagation)
            e.stopPropagation();
        this._save();

    }

    private _save = () => {
        var data = this.state.preferences.DefaultSytemSetting;
        data.DefaultGroupIDs = this.state.selectEntitlementIDs;
        data.DefaultRoleIDs = this.state.selectRoleIDs;
        UserActions.saveSystemSettings(data, () => {
            this.props.onClose();
        }, null);
    }

    private _onCancel = (e: any) => {
        if (this.state.dirty) {
            SystemActions.displaySaveChangesDialog({
                message: InovxLoader.t("common:msgBox.saveChanges"),
                confirmCallback: () => {
                    this._save();
                },
                cancelCallback: () => {
                    this.props.onClose();
                }
            });
        }
        else {
            this.props.onClose();
        }
    }

    private _onReset = (e: any) => {
        this.setState({
            dirty: true,
            preferences: {
                DefaultSytemSetting: {
                    DefaultGroupIDs: this._preferences.DefaultSytemSetting.DefaultGroupIDs.slice(0),
                    DefaultRoleIDs: this._preferences.DefaultSytemSetting.DefaultRoleIDs.slice(0)
                },
                AllGroups: this._preferences.AllGroups.slice(0),
                AllRoles: this._preferences.AllRoles.slice(0)
            },
            selectEntitlementIDs: this._preferences.DefaultSytemSetting.DefaultGroupIDs,
            selectRoleIDs: this._preferences.DefaultSytemSetting.DefaultRoleIDs
        });
    }

    private _checkForUnsavedChangesWindow = (e: any) => {
        if (this.state.dirty) {
            e.returnValue = InovxLoader.t('users:message.unsavedPreferences');
        }
    }

    private _canSelectRole = (roleObj: INamedItem) => {
        const isLinkedRole = this._linkedRoles.some(role => role.ID === roleObj.ID);

        if (isLinkedRole) {
            var messageObject = {
                message: InovxLoader.t('users:message.linkedRoleCannotAdd')
            }
            SystemActions.displayWarningMessage(messageObject);
            return false;
        }

        return true;
    }

    private _canSelectEntitlement = (entitlementObj: INamedItem) => {
        const isLinkedGroup = this._linkedEntitlements.some(group => group.ID === entitlementObj.ID);

        if (isLinkedGroup) {
            var messageObject = {
                message: InovxLoader.t('users:message.linkedGroupCannotAdd')
            }
            SystemActions.displayWarningMessage(messageObject);
            return false;
        }

        return true;

    }

    private _onRolesSelect = (roleObj: INamedItem, selected: boolean) => {
        this._onSelect('RoleIDs', roleObj, selected);
    }

    private _onEntitlementSelect = (entitlementObj: INamedItem, selected: boolean) => {
        this._onSelect('EntitlementGroupIDs', entitlementObj, selected);

    }

    private _onSelect = (name: string, obj: INamedItem, selected: boolean) => {
        var array: string[] = [];
        if (selected) {
            //Add
            if (name === "EntitlementGroupIDs") {
                var array = this.state.selectEntitlementIDs.slice(0);
                array.push(obj.ID);


            }
            else {
                var array = this.state.selectRoleIDs.slice(0);
                array.push(obj.ID);

            }


        } else {
            //Remove
            if (name === "EntitlementGroupIDs") {
                array = this.state.selectEntitlementIDs.slice(0);
                const index = this.state.selectEntitlementIDs.indexOf(obj.ID);
                if (index > -1) {
                    array.splice(index, 1);
                }
            }
            else {
                array = this.state.selectRoleIDs.slice(0);
                const index = this.state.selectRoleIDs.indexOf(obj.ID);
                if (index > -1)
                    array.splice(index, 1);
            }
        }
        if (name === "EntitlementGroupIDs") {
            this.setState({
                selectEntitlementIDs: array,
                dirty: true
            });
        } else {
            this.setState({
                selectRoleIDs: array,
                dirty: true
            });
        }
    }

    private _onSystemChange = () => {
        this.setState({
            isActionInProgress: getActionInProgress()
        } as any);
    }


    public render() {
        return (
            <Inovx.Shared.Core.ReactLoader appReady={this.isAppLoaded()} errorStatus={this._errorStatus}>

                <div className="user-preferences-popup no-print" id="user-preferences-popup">
                    <Inovx.Shared.Controls.If condition={this.state.isActionInProgress} class={'temp-modal-loader'}>
                        <div className="action-in-progress-loader-lrg"></div>
                    </Inovx.Shared.Controls.If>

                    <div className="panel panel-primary user-preferences-app-content">
                        <div className="panel-heading">{InovxLoader.t("users:preferences.title")}
                            <a href="#" onClick={this._onCancel} >
                                <span className="pull-right glyphicon glyphicon glyphicon-remove"></span>
                            </a>
                        </div>
                        <div className="panel-body">
                            <div className="user-form">
                                <InovxControls.If condition={true} class='fc-margin'>
                                    <InovxControls.GroupBox title={InovxLoader.t('users:preferences.entitlement')} class="gb-user-entitlement">
                                        <InovxControls.FormField title={InovxLoader.t("users:common.entitlement")} inputName='Entitlement'>
                                            <InovxControls.MultiSelect displayProp="Name" minLength={0} onSelect={this._onEntitlementSelect} datasource={this.state.preferences.AllGroups} keyProp="ID"
                                                valueProp="ID" values={this.state.selectEntitlementIDs} preventInternalSelect={true} canSelect={this._canSelectEntitlement} />
                                        </InovxControls.FormField>
                                    </InovxControls.GroupBox>
                                </InovxControls.If>

                                <InovxControls.If condition={true} class='fc-margin'>
                                    <InovxControls.GroupBox title={InovxLoader.t('users:preferences.roles')} class="gb-user-roles">
                                        <InovxControls.FormField title={InovxLoader.t("users:common.roles")} inputName='Role'>
                                            <InovxControls.MultiSelect displayProp="Name" minLength={0} onSelect={this._onRolesSelect} datasource={this.state.preferences.AllRoles} keyProp="ID"
                                                valueProp="ID" values={this.state.selectRoleIDs} preventInternalSelect={true} canSelect={this._canSelectRole} />
                                        </InovxControls.FormField>
                                    </InovxControls.GroupBox>
                                </InovxControls.If>
                            </div>
                        </div>
                        <div className="panel-footer clearfix">
                            <div className="row">
                                <div className="pull-left">
                                    <button type="button" id="preferences.btn.reset" className="btn btn-info btn-left" onClick={this._onReset}>{InovxLoader.t("users:preferences.resetButton")}</button>
                                </div>
                                <div className="pull-right">
                                    <button type="button" id="preferences.btn.save" className="btn btn-primary btn-space" onClick={this._onSave}>{InovxLoader.t("users:preferences.saveButton")}</button>
                                    <button type="button" id="preferences.btn.cancel" className="btn btn-primary btn-right" onClick={this._onCancel}>{InovxLoader.t("users:preferences.cancelButton")}</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </Inovx.Shared.Core.ReactLoader>
        );
    }
}
export default UserSystemPreferences;
